import groupSelection from "./en/en_groupSelection";
import memberLayout from "./en/memberLayout";
import menu from "./en/menu";
import adminLayout from "./en/adminLayout";
import noGroup from "./en/noGroup";
import memberDashboard from "./en/memberDashboard";
export default {
  groupSelection,
  memberLayout,
  menu,
  adminLayout,
  noGroup,
  memberDashboard,
  auth: {
    signIn: "Sign in",
    signInHelp: "Enter your registered email to receive a verification code.",
    email: "Email",
    emailPlaceholder: "name{'@'}example.com",
    sendCode: "Send Code",
    verificationCode: "Verification Code",
    verifyAndLogin: "Verify and Login",
    backHome: "Back to Home",
    brandDescription:
      "Secure, modern and reliable platform for managing group savings, loans and financial accountability.",
    featureSecure: "Secure Email Authentication",
    featureTracking: "Track Contributions and Loans",
    featureMembers: "Transparent Member Management",
    codeSent:
      "If the email exists, a verification code has been sent.",
    sendCodeFailed: "Failed to send the verification code.",
    verificationFailed: "Verification failed.",
    rightsReserved: "All rights reserved.",
  },
  "home": {
    "nav": {
      "about": "About",
      "features": "Features",
      "howItWorks": "How It Works",
      "faq": "FAQ",
      "toggleTheme": "Toggle dark mode",
      "login": "Login",
      "requestDemo": "Request Demo"
    },
    "hero": {
      "chip": "Modern savings and credit operations",
      "title": "Track Contributions, Manage Loans, and Grow with Confidence",
      "description": "A professional digital platform for savings groups, cooperatives, associations, and community organizations to manage contributions, loans, profits, penalties, members, and reports in one secure place.",
      "requestDemo": "Request a Demo",
      "exploreFeatures": "Explore Features",
      "badges": {
        "transparent": "Transparent Records",
        "secure": "Secure Access",
        "reports": "Smart Reports"
      }
    },
    "dashboard": {
      "highlights": "System Highlights",
      "liveOverview": "Live overview",
      "stats": {
        "contributions": "Total Contributions",
        "loans": "Active Loans",
        "profit": "Profit",
        "penalties": "Penalties"
      }
    },
    "trust": {
      "memberManagement": "Member Management",
      "loanTracking": "Loan Tracking",
      "penaltyControl": "Penalty Control",
      "reportsInsights": "Reports & Insights"
    },
    "partners": {
      "title": "Designed for Growing Organizations",
      "subtitle": "Suitable for community-based financial groups and institutions that need order, transparency, and growth.",
      "items": [
        "Savings Groups",
        "Cooperatives",
        "Community Associations",
        "Women Groups",
        "Youth Groups",
        "Faith-Based Groups"
      ]
    },
    "about": {
      "title": "About the Platform",
      "paragraph1": "This savings and credit management platform helps organizations digitize financial operations and manage member activities with confidence.",
      "paragraph2": "From member contributions and loan repayments to profit sharing, penalties, and reporting, the system brings together the core functions needed to improve accountability, transparency, and efficiency.",
      "quickStats": [
        {
          "title": "Secure",
          "text": "Protected records and controlled access"
        },
        {
          "title": "Smart",
          "text": "Powerful reporting and useful analytics"
        },
        {
          "title": "Flexible",
          "text": "Supports different group structures"
        },
        {
          "title": "Reliable",
          "text": "Built for day-to-day financial operations"
        }
      ],
      "points": [
        {
          "title": "Centralized Financial Tracking",
          "text": "Keep all your records in one place and reduce paperwork."
        },
        {
          "title": "Clear Member Accountability",
          "text": "Track member activities and improve trust through clear records."
        },
        {
          "title": "Actionable Reporting",
          "text": "Access insights that support better decisions and planning."
        }
      ]
    },
    "features": {
      "title": "Core Features",
      "subtitle": "Everything needed to simplify savings, loans, and financial tracking.",
      "items": [
        {
          "title": "Contribution Management",
          "description": "Track contributions, commitments, payment history, balances, and missed payments with accuracy."
        },
        {
          "title": "Loan Management",
          "description": "Manage loan applications, approvals, disbursements, repayment schedules, and balances."
        },
        {
          "title": "Profit Tracking",
          "description": "Monitor profits and prepare transparent profit-sharing for members or stakeholders."
        },
        {
          "title": "Penalty Handling",
          "description": "Capture overdue amounts, missed contributions, and penalties in an organized way."
        },
        {
          "title": "Member & Beneficiary Records",
          "description": "Maintain member profiles, beneficiaries, commitments, activity history, and participation records."
        },
        {
          "title": "Reports & Dashboards",
          "description": "View summaries, monitor trends, and generate useful financial reports for leadership."
        }
      ]
    },
    "steps": {
      "title": "How It Works",
      "subtitle": "A simple journey from setup to better financial decision-making.",
      "items": [
        {
          "title": "Register Members",
          "description": "Create member profiles, set commitments, and organize beneficiaries and roles."
        },
        {
          "title": "Track Financial Activities",
          "description": "Record contributions, disburse loans, capture repayments, profits, and penalties."
        },
        {
          "title": "Review Reports",
          "description": "Use dashboards and reports to monitor performance and improve transparency."
        }
      ]
    },
    "benefits": {
      "title": "Why Choose This System?",
      "subtitle": "Built to reduce manual work and improve trust in financial operations.",
      "items": [
        {
          "title": "Better Transparency",
          "description": "Every transaction is properly recorded for accountability."
        },
        {
          "title": "Less Manual Work",
          "description": "Reduce paperwork and repetitive calculations."
        },
        {
          "title": "Improved Decision-Making",
          "description": "Use clean reports and insights to guide the group."
        },
        {
          "title": "Professional Operations",
          "description": "Present a more organized and reliable system to members."
        }
      ]
    },
    "testimonials": {
      "title": "What Organizations Value",
      "subtitle": "A few examples of the kind of value this platform can bring.",
      "items": [
        {
          "name": "Group Treasurer",
          "role": "Community Savings Group",
          "message": "The platform helps us keep accurate records of contributions and loan repayments, which has improved trust among members."
        },
        {
          "name": "Operations Lead",
          "role": "Cooperative Organization",
          "message": "Reporting is much easier and more professional. We can quickly understand group performance without relying on manual books."
        },
        {
          "name": "Association Coordinator",
          "role": "Member-Based Association",
          "message": "Having contributions, penalties, and member records in one system makes administration simpler and more transparent."
        }
      ]
    },
    "cta": {
      "title": "Ready to Modernize Your Savings Operations?",
      "subtitle": "Request a demo and discover how the platform can support your group or organization.",
      "button": "Book Your Demo"
    },
    "demo": {
      "title": "Request a Demo",
      "subtitle": "Fill out the form and we’ll contact you to schedule a demonstration.",
      "responseTime": "We respond to demo requests as soon as possible.",
      "points": [
        "Personalized system walkthrough",
        "Explanation of features for your organization",
        "Guidance on implementation and usage"
      ],
      "form": {
        "fullName": "Full Name",
        "fullNamePlaceholder": "Enter your full name",
        "organization": "Organization",
        "organizationPlaceholder": "Organization name",
        "email": "Email Address",
        "emailPlaceholder": "you{'@'}example.com",
        "phone": "Phone Number",
        "phonePlaceholder": "+250...",
        "message": "Message",
        "messagePlaceholder": "Tell us about your group, cooperative, or organization...",
        "submitting": "Submitting...",
        "submit": "Submit Demo Request"
      },
      "messages": {
        "success": "Your demo request has been submitted successfully.",
        "validation": "Please correct the highlighted fields.",
        "error": "Something went wrong while submitting your request."
      }
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "subtitle": "Answers to common questions about the platform.",
      "items": [
        {
          "question": "Who is this system designed for?",
          "answer": "It is designed for savings groups, cooperatives, SACCOs, associations, NGOs, and other organizations that manage contributions, loans, and member-based financial activities."
        },
        {
          "question": "Can the system track loans and repayments?",
          "answer": "Yes. The platform can manage loan records, repayment tracking, and outstanding balances in an organized way."
        },
        {
          "question": "Does it support profits and penalties?",
          "answer": "Yes. You can track profits, penalties, overdue payments, and other important financial activities."
        },
        {
          "question": "Can we request a demo before adopting it?",
          "answer": "Yes. The landing page includes a demo request form so interested organizations can schedule a walkthrough."
        },
        {
          "question": "Can the system be customized?",
          "answer": "Yes. Depending on your requirements, features and workflows can be adjusted to fit your group or organization."
        }
      ]
    },
    "footer": {
      "description": "A modern platform for savings groups, cooperatives, and organizations to manage contributions, loans, profits, and reports.",
      "quickLinks": "Quick Links",
      "modules": "System Modules",
      "contact": "Contact",
      "contributions": "Contributions",
      "loans": "Loans",
      "profits": "Profits",
      "reports": "Reports",
      "email": "Email",
      "phone": "Phone",
      "location": "Location",
      "rights": "All rights reserved.",
      "tagline": "Track contributions. Manage loans. Grow together."
    },
    "floatingCta": "Jump to demo request"
  }
};